import { CautionsTabLocationsView, EventPanelMetadata } from '@mark43/cad-api';
import { useEventMetadataStore } from '../event-panel/event-panel-form/event-metadata';
import { CorrectedLocation } from '../fr-entity-panels/types';
import { FrEntityLocationSelectValueDisplay } from '../fr-entity-panels/components/fr-entity-location-select-value-display';

export function FrEventLocationSelectValueDisplay(props: {
    showComplementaryContent?: boolean;
    cautions?: CautionsTabLocationsView;
    areCautionsLoading?: boolean;
    specificEntityLocation?: CorrectedLocation;
}) {
    const { highestPriorityLocationCaution, isNearbyLocationCautionPriority1, eventId } =
        useEventMetadataStore()?.state?.metadata ?? ({} as EventPanelMetadata);

    return (
        <FrEntityLocationSelectValueDisplay
            entityType="EVENT"
            entityId={eventId}
            cautionProps={{ highestPriorityLocationCaution, isNearbyLocationCautionPriority1 }}
            {...props}
        />
    );
}
